import Header from "../components/Header";
import Banner from "../components/Banner";
import Stats from "../components/Stats";
import OverviewSection from "../components/OverviewSection";
import Courses from "../components/Courses";
import TrainingOptions from "../components/TrainingOptions";
import PlacementSupport from "../components/PlacementSupport";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";

export default function HomePage() {
  return (
    <>
      <Header />
      <Banner />
      <Stats />
      <OverviewSection />
      <Courses />
      <TrainingOptions />
      <PlacementSupport />
      <FinalCTA />
      <Footer />
    </>
  );
}
